import * as React from 'react'
import createSvgIcon from '../createSvgIcon'

export default createSvgIcon(
  <>
    <path d='M19 21.6484H5C4.73478 21.6484 4.48043 21.543 4.29289 21.3555C4.10536 21.1679 4 20.9136 4 20.6484V11.6484H1L11.327 2.26036C11.5111 2.09284 11.7511 2 12 2C12.2489 2 12.4889 2.09284 12.673 2.26036L23 11.6484H20V20.6484C20 20.9136 19.8946 21.1679 19.7071 21.3555C19.5196 21.543 19.2652 21.6484 19 21.6484ZM14 19.6484H18V9.80536L12 4.35136L6 9.80536V19.6484H10V13.6484H14V19.6484Z' />
  </>,
  'Home'
)
